// Components==============
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './ColorProfileHome.module.scss';
// import Colors from 'pages/Growth/GrowthPortfolio/components/Overview/components/Colors/Colors';
// import Colors from 'pages/Growth/GrowthPortfolio/components/Colors/Colors';
import { AnimatePresence, motion } from 'framer-motion';
import { framerMountAndScale } from 'utilities/FramerAnimations';
// import { useMediaQ } from 'hooks/useMediaQ';
// import Avatar from 'components/UI/Avatar/Avatar';
import ColorProfileModal from '../ColorProflieModal/ColorProfileModal';
// =========================

export default function ColorProfileHome() {
  const translate = useTranslate();
  const [colorProfileModalIsOpen, setColorProfileModalIsOpen] = React.useState(
    false
  );
  // const query = useMediaQ('min', 525);

  return (
    <>
      <div styleName="column">
        <strong>{translate('reflection.terms.my-color-profile')}</strong>
        <motion.div
          {...framerMountAndScale}
          styleName="card"
          onClick={() => setColorProfileModalIsOpen(true)}
        >
          {/* <Colors
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        /> */}
          <img
            styleName="image"
            src="/images/colorprofile-colored.svg"
            alt="kleuren profiel"
          />

          {/* {query && (
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <Avatar size="big" border />
            </div>
          )} */}
        </motion.div>
      </div>
      <AnimatePresence>
        {colorProfileModalIsOpen && (
          <ColorProfileModal
            setColorProfileModalIsOpen={setColorProfileModalIsOpen}
          />
        )}
      </AnimatePresence>
    </>
  );
}
